module.exports = require("error-stack-parser");